import React, { useEffect } from "react"; 
import { getLoggedInUserGUID, getTimeZoneID, getTimeZoneText, GetAssessmentName } from '../../../../src/web/components/utils';
import { useLocation } from 'react-router-dom';
import routes from '../../../../src/web/config/route';
import { storeActions, storeState } from '../../../store/hooks';
const Etcetras: React.FC = React.memo((): JSX.Element => {
    const { pathname } = useLocation();
    const location = useLocation();
    // console.log({location });
    const setCrumbs = storeActions((actions: any) => actions.app.setCrumbs);
    useEffect(() => {
        if (pathname) {
            prepareBreadCrumb(pathname);
        }
    }, [pathname])

    const prepareBreadCrumb = (currentPath: string) => {
        console.log('prepareBreadCrumb', currentPath)
        const crumbs = routes.filter(({ path }) => {
            // console.log('prepareBreadCrumb')
            // console.log('/'+currentPath?.slice(0, currentPath.lastIndexOf('/')).split('/').slice(1, 3).join('/'))
            // console.log(currentPath?.slice(0, currentPath?.indexOf("/", currentPath?.indexOf("/") +1)))
            // return path.includes(currentPath)
            // console.log(path)
            return path.substring(0, path.indexOf(":")-1) === '' ? currentPath.includes(path) : currentPath.startsWith(path.substring(0, path.indexOf(":")-1))
        }
        ).filter((item:any)=>item.name!='').map(({ name, goBackPath }) => {
            return { name: name, path: goBackPath };
        });
        console.log('--crumbs--')
        console.log(crumbs)
        setCrumbs(crumbs);
    }

    return <></>;
});

export default Etcetras;